const ServiceData = {
    "projects_management": {
        crum: "Projects Management",
        title: "Turning Vision into Reality",
        backgroundPosition: 'center bottom',
        subtitle:
            "Every successful project begins with a solid foundation of expertise and planning.",
        description:
            "PMC delivers comprehensive oversight for complex development and construction projects. Our suite of services ensures excellence in planning, execution, and delivery, with a focus on efficiency, quality, and successful outcomes.",
        image: "/service/14456.jpg",
        consultancy: {
            title: "Our Project Management Services",
            sections: [
                {
                    id: 1,
                    image: "/icons/Project-Management.png",
                    heading: "Project <br/> Management",
                    content:
                        " We apply industry best practices to manage every phase of your project—from initial planning through execution and final delivery—ensuring adherence to time and budget.",
                },
                {
                    id: 2,
                    image: "/icons/Construction-Management.png",
                    heading: "Construction <br/> Management",
                    content:
                        "Our specialists oversee on-site operations, ensuring that construction activities meet the highest standards for quality, safety, and regulatory compliance.",
                
                },
                {
                    id: 3,
                    image: "/icons/Program-Management.png",
                    heading: "Programme <br/> Management",
                    content:
                        "We strategically coordinate multiple interrelated projects, aligning resources and timelines to deliver a cohesive and impactful project portfolio.",
                
                },
                {
                    id: 4,
                    image: "/icons/Expert-Witness-Arbitration.png",
                    heading: "Expert Witness <br/> & Arbitration",
                    content:
                        " Our experienced professionals provide independent analysis and arbitration support to resolve project-related disputes with integrity.",
                
                },
                {
                    id: 5,
                    image: "/icons/Estimating.png",
                    heading: "Estimating<br/> & Cost Management",
                    content:
                        "We deliver accurate cost estimations and implement robust budget monitoring practices to ensure financial transparency and control throughout the project lifecycle.",
                
                },
                {
                    id: 6,
                    image: "/icons/Cost-Consultation-Services.png",
                    heading: "Cost Consultation<br/> Services",
                    content:
                        "Our advisory services focus on optimizing project budgets through detailed cost analysis, value engineering, and strategic planning.",
                
                },
                {
                    id: 7,
                    image: "/icons/Risk-sustainability.png",
                    heading: "Risk & Sustainability<br/> Consulting",
                    content:
                        "Develop and monitor financial KPIs to ensure continuous improvement and alignment with business objectives.",
                
                },
                {
                    id: 8,
                    image: "/icons/Troubled-Project.png",
                    heading: "Troubled Project<br/> Back-On-Track",
                    content:
                        "Leveraging proven recovery methodologies, our specialists diagnose issues and implement corrective measures to realign projects with their original objectives.",
                
                },
                {
                    id: 9,
                    image: "/icons/Fit-out-Management.png",
                    heading: "Fit-out<br/> Management",
                    content:
                        "We manage fit-out projects with meticulous attention to detail, ensuring that interior spaces are executed to the highest standards and client specifications.",
                
                }
            ],
        },
        KeyBenefits: {
            title: "Key Benefits",
            description:
            "We identify and procure the best products from leading international suppliers.",
            image: "/service/project1.png",
            points: [
                {
                    title: "Holistic project planning that aligns with business goals.",
                
                },
                {
                    title: "Cross-functional coordination ensuring efficiency and accountability.",
                
                },
                {
                    title: "Transparent reporting and performance monitoring at every stage",
               
                },
                {
                    title: "Delivery-focused solutions balancing time, quality, and budget constraints.",
        
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Trading",
            content:
                "At Burooj Trading, we are committed to connecting businesses in Oman with high-quality international products while ensuring smooth and cost-effective trade operations. Whether you are looking for product sourcing, trade finance, or market expansion, our team is here to support your business every step of the way.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/service/19576.jpg",
        },
    },
    "management_consultancy": {
        crum: "Management Consultancy",
        title: "Operational & Digital Transformation",
        backgroundPosition: 'center center',
        subtitle: "Effective management isn’t just about maintaining operations—it’s about maximizing efficiency and unlocking new potential.",
        description: `PMC Oman works closely with organizations to enhance performance, optimize resources, and implement strategic frameworks that drive growth in a competitive business landscape.PMC’s Management Consultancy services empower your organization to excel in today’s dynamic business landscape. We combine rigorous operational expertise with innovative digital strategies to drive efficiency, enhance performance, and sustain long-term growth.`,
        image: "/service/30564.jpg",
        consultancy: {
            title: "Our Management Consultancy Services",
            sections: [
                {
                    id: 1,
                    image: "/icons/Strategic-Advisory.png",
                    heading: "Strategic <br/>Advisory",
                    content:
                        " Develop actionable business strategies tailored to your vision and market dynamics, ensuring a robust competitive edge.",
                },
                {
                    id: 2,
                    image: "/icons/Operational-Excellence.png",
                    heading: "Operational<br/> Excellence",
                    content:
                        "Integrate advanced digital tools and data analytics into your operations to improve decision-making and drive innovation.",
                
                },
                {
                    id: 3,
                    image: "/icons/Change-Management.png",
                    heading: "Change <br/>Management",
                    content:
                        "Utilize structured frameworks to guide your organization through transitions, ensuring smooth implementation and stakeholder alignment.",
                
                },
                {
                    id: 4,
                    image: "/icons/Digital-Transformation.png",
                    heading: "Digital<br/> Transformation",
                    content:
                        "Integrate advanced digital tools and data analytics into your operations to improve decision-making and drive innovation.",
                
                },
                { id: 5,
                    image: "/icons/Performance-Measurement.png",
                    heading: "Performance<br/> Measurement",
                    content:
                        "Design and monitor key performance indicators (KPIs) to track progress, enhance accountability, and drive continuous improvement.",
                
                },
                {
                    id: 6,
                    image: "/icons/Stakeholder-Engagement.png",
                    heading: "Stakeholder<br/> Engagement",
                    content:
                        "Strengthen communication and collaboration across your organization to ensure effective execution of strategic initiatives.",
                
                },
                {
                    id: 7,
                    image: "/icons/Risk-Sustainability-1.png",
                    heading: "Risk & Sustainability<br/> Consulting",
                    content:
                        "Develop comprehensive risk management and sustainability strategies that protect your business and support long-term resilience.",
                
                },
            ],
        },
        KeyBenefits: {
            title: "Key Benefits",
            description:
            "We identify and procure the best products from leading international suppliers.",
            image: "/service/Consultancy.png",
            points: [
                {
                    title: "Increased efficiency through customized process improvements.",
                
                },
                {
                    title: "Enhanced decision-making with real-time insights.",
                
                },
                {
                    title: "Stronger alignment between corporate strategy and operational execution.",
               
                },
                {
                    title: "Scalable growth strategies that prepare businesses for future challenges.",
        
                },
            ],
        },
        callToAction: {
            title: "Partner with Burooj Investments",
            content:
                "Investing is more than numbers—it’s about vision, resilience, and the ability to turn opportunities into success stories. Whether you are a startup seeking capital, a business looking for strategic investment, or an investor aiming for high-value returns, Burooj Investments is your trusted partner. Let’s build the future of investment together.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/open-service-2-1.png",
        },
    },
    "arbitrary_&_legal": {
        crum: "Arbitration & Legal Services",
        title: "Arbitration & Legal Dispute Resolution",
        backgroundPosition: 'center center',
        subtitle:
            `Construction arbitration is not only about resolving disputes—it’s about keeping projects on 
track and securing outcomes that protect investments`,
        description:
            `PMC Oman provides dedicated arbitration and legal services focused on resolving disputes 
within the construction and infrastructure sector. Our expertise lies in handling complex 
construction claims, project delays, cost overruns, contract breaches, and disputes involving 
contractors, subcontractors, developers, and investors. Through both domestic and international 
arbitration frameworks, we help clients achieve practical resolutions that safeguard project 
timelines, financial interests, and long-term business relationships`,
            image: "/service/126.jpg",
        consultancy: {
            title: "Our Arbitration & Legal Services",
            sections: [
                {
                    id: 1,
                    image: "/icons/Corporate-Finance-Advisory.png",
                    heading: "Contractual Disputes in<br/> Construction Projects",
                    content:
                        `Resolution of disputes arising from contract interpretation, scope variations, payment 
defaults, and performance obligations under FIDIC and other construction frameworks.`,
                },
                {
                    id: 2,
                    image: "/icons/Financial-Modeling-1.png",
                    heading: "Delay &<br/>Disruption Claims",
                    content:
                        `Specialized handling of claims involving project delays, extensions of time, and 
disruption-related damages`,
                
                },
                {
                    id: 3,
                    image: "/icons/Cost-Optimization.png",
                    heading: "Cost Overruns &<br/>Payment Disputes",
                    content:
                        `Arbitration services covering disputes on budget escalation, variations in project cost, and
non-payment between parties.`,
                
                },
                {
                    id: 4,
                    image: "/icons/Risk-sustainability.png",
                    heading: "Defects &<br/>Quality-Related Claims",
                    content:
                        `Addressing issues related to defective work, construction quality, warranties, and liability
for rectification`,
                
                },
                {
                    id: 5,
                    image: "/icons/Investment-Market-Research.png",
                    heading: "Real Estate &<br/> Infrastructure Arbitration",
                    content:
                        `Expert arbitration services for disputes involving developers, investors, and contractors in
residential, commercial, and government infrastructure projects.`,
                
                },
                {
                    id: 6,
                    image: "/icons/Capital-Structuring.png",
                    heading: "Cross-Border<br/> Construction Arbitration",
                    content:
                        "Handling international construction disputes under ICC, LCIA, DIAC, and other recognized forums, with enforceable outcomes across jurisdictions.",
                
                },
                {
                    id: 7,
                    image: "/icons/Performance-Measurement.png",
                    heading: "Award Enforcement in<br/>Oman & Abroad",
                    content:
                        `Assistance in recognition and enforcement of arbitral awards, ensuring compliance and 
execution both locally and internationally.`,
                
                },
                // {
                //     id: 8,
                //     image: "/icons/Strategic-Financial-Planning.png",
                //     heading: "Strategic Financial <br/>Planning",
                //     content:
                //         "Develop detailed, actionable strategies that propel your organization toward sustainable growth and lasting value.",
                
                // }
            ],
        },
        KeyBenefits: {
            title: "Key Benefits",
            description:
            "We identify and procure the best products from leading international suppliers.",
            image: "/service/project.png",
            points: [
                {
                    title: "Quicker dispute resolution than litigation, keeping construction projects on schedule.",
               
                },
                {
                    title: "Allows appointment of arbitrators skilled in construction contracts and standards.",
        
                },
                {
                    title: "Produces enforceable awards under Omani law and global arbitration conventions.",
                
                },
                {
                    title: "Preserves strong business relations by promoting structured resolution among stakeholders.",
                
                },
                
            ],
        },
        callToAction: {
            title: "Partner with Burooj Properties",
            content:
                "Every property has a story. Whether you're an investor, landlord, or business, we help you write a profitable chapter. Reach out today to discuss how we can add value to your real estate assets.",
            buttonText: "Contact Us",
            buttonLink: "/contacts/",
            image: "/imges/service/Partner.jpg",
        },
    },
    
};
export default ServiceData;